<template>
  <v-overlay data-cy="aurora-auth-overlay" :value="network.busy">
    <v-card>
      <v-card-title data-cy="aurora-auth-overlay-title">
        Logging you back in...
      </v-card-title>
      <v-card-text class="text-center">
        <ProgressCircularTimeout />
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import {
  VOverlay,
  VCard,
  VCardTitle,
  VCardText,
} from 'vuetify/lib';
import authHub from '../authHub';
import ProgressCircularTimeout from './ProgressCircularTimeout.vue';

export default {
  name: 'Auth',
  components: {
    ProgressCircularTimeout,
    VOverlay,
    VCard,
    VCardTitle,
    VCardText,
  },
  data() {
    return {
      network: {
        busy: false,
        retries: 0,
      },
    };
  },
  computed: {
    ...mapState('organizations', ['organization']),
  },
  methods: {
    ...mapMutations('auth', ['SET_isLoggedIn', 'SET_roles', 'SET_username', 'SET_userId']),
  },
  async created() {
    this.$log.debug('setting up listeners');
    authHub.$on('network:unauthorized', async (n) => {
      this.$log.warn(n, this.network.busy);
      if (!this.network.busy) {
        if (this.network.retries > 3) {
          this.$root.$emit('auth:logoff');
        } else {
          // refresh token
          try {
            this.network.busy = true;
            this.network.retries += 1;
            this.$log.debug(`retries: ${this.network.retries}`);
            await this.$auth.refreshToken();
            this.$root.$emit('page.refresh');
          } catch (error) {
            this.$log.error(error);
            setTimeout(() => {
              authHub.$emit('network:unauthorized', {
                source: 'retry',
              });
            }, 2000);
          } finally {
            this.network.busy = false;
          }
        }
      } else {
        this.$log.info('ignoring unauthorized request as the refresh token request is busy');
      }
    });
    this.$root.$on('auth:login', () => {
      this.SET_isLoggedIn(true);
      const token = this.$auth.getToken();
      this.SET_roles(token.roles);
      this.SET_username(token.userName);
      this.SET_userId(token.userId);
      this.network.retries = 0;
      this.$log.info('reset network retries');
    });
    this.$root.$on('auth:logoff', () => {
      this.$log.debug('logging off and clearing local storage');
      this.SET_isLoggedIn(false);
      this.SET_roles([]);
      this.SET_username('');
      this.SET_userId('');
      this.$auth.logoff();
      this.$log.info('logged off');
    });
    this.$log.debug('auth created');
  },
};
</script>
